// import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
// Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-philosophy')) {
  // #page-philosophyがあるページだけで実行
  window.intObs = function () {
    if (document.getElementsByClassName('js-philosophyIntro')[0]) {
      const intObsOption = {
        // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
        rootMargin: '-1% 0px -99% 0px', // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
        threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
      }
      const observer = new IntersectionObserver(intObsCallback, intObsOption)
      const intObsItems = document.querySelectorAll('.js-philosophyIntro')
      for (let index = 0; index < intObsItems.length; index++) {
        const intObsItem = intObsItems[index]
        observer.observe(intObsItem) // 監視対象に加える
      }
      function intObsCallback(entries) {
        for (let index = 0; index < entries.length; index++) {
          const entry = entries[index]
          const entryItem = entry.target
          if (entry.isIntersecting) {
            entryItem.classList.add('fixed')
          } else {
            entryItem.classList.remove('fixed')
          }
        }
      }
    }
  }
  window.intObs() // 画面交差API起動

  // 1文字ずつ表示
  const targets = document.querySelectorAll('.js-philosophyTyping')

  targets.forEach((section) => {
    section.querySelectorAll('h2, p').forEach((el) => {
      const nodes = Array.from(el.childNodes)
      let html = ''

      nodes.forEach((node) => {
        if (node.nodeType === 3) {
          html += node.textContent
            .split('')
            .map((char) => {
              if (char === ' ') return ' '
              return `<span class="char">${char}</span>`
            })
            .join('')
        } else if (node.nodeType === 1) {
          html += node.outerHTML
        }
      })

      el.innerHTML = html
    })

    const chars = section.querySelectorAll('.char')
    const total = chars.length

    let currentCount = 0 // 今表示している文字数
    let targetCount = 0 // スクロールから求めた目標文字数
    let ticking = false

    function updateTarget() {
      const rect = section.getBoundingClientRect()
      const windowH = window.innerHeight

      const start = windowH
      const end = windowH * 0.2 - rect.height / 2

      const progress = Math.min(Math.max((start - rect.top) / (start - end), 0), 1)
      targetCount = Math.floor(total * progress)

      if (!ticking) animate()
    }

    function animate() {
      ticking = true

      if (currentCount < targetCount) {
        currentCount++
      } else if (currentCount > targetCount) {
        currentCount--
      }

      chars.forEach((char, i) => {
        char.classList.toggle('is-visible', i < currentCount)
      })

      if (currentCount !== targetCount) {
        requestAnimationFrame(animate)
      } else {
        ticking = false
      }
    }

    window.addEventListener('scroll', updateTarget)
    window.addEventListener('resize', updateTarget)
    updateTarget()
  })

  // 紙芝居
  document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.philosophyPromise__block')
    const items = document.querySelectorAll('.js-philosophyPromise__item')
    const total = items.length

    const BREAKPOINT = 768
    let isEnabled = window.innerWidth > BREAKPOINT
    let resizeTimer = null

    function updateAnimation() {
      if (!isEnabled) return

      const rect = section.getBoundingClientRect()
      const windowH = window.innerHeight

      const progress = Math.min(Math.max(-rect.top / (rect.height - windowH), 0), 1)

      items.forEach((item, index) => {
        if (index === 0) return

        const start = (index - 1) / (total - 1)
        const end = index / (total - 1)

        let localProgress = (progress - start) / (end - start)
        localProgress = Math.min(Math.max(localProgress, 0), 1)

        item.style.transform = `translateY(${(1 - localProgress) * 100}%)`
      })
    }

    function checkViewport() {
      const shouldEnable = window.innerWidth > BREAKPOINT

      if (shouldEnable !== isEnabled) {
        isEnabled = shouldEnable

        if (!isEnabled) {
          // 無効時は transform をリセット
          items.forEach((item) => (item.style.transform = ''))
        } else {
          updateAnimation()
        }
      }
    }

    // スクロール
    window.addEventListener('scroll', updateAnimation, { passive: true })

    // リサイズ（0.5秒後に判定）
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer)
      resizeTimer = setTimeout(() => {
        checkViewport()
        updateAnimation()
      }, 500)
    })

    // 初回実行
    checkViewport()
    updateAnimation()
  })
}
